import { ShopLight } from "@/abilities/shop/types/shop-light";
import { useGetShopLightConfigLazyQuery } from "@/shared/services/graphql/generated/consumer-graph-types";

export const loadShopLightConfig = async (): Promise<ShopLight.Config | null> => {
    const { load } = useGetShopLightConfigLazyQuery();
    const data = await load();
    if (data && data.getShopLightConfig) {
        const { id, shopServiceUrl, shopEMail } = data.getShopLightConfig;
        if (!shopEMail || !id || !shopServiceUrl) {
            return null;
        }
        return {
            shopEMail,
            id,
            shopServiceUrl,
        };
    } else {
        return null;
    }
};
